<template>
  <div class="app-wrap">
    <div :span="24" class="padding24 h100 overflow-x-y">
      <div class="search" style="height: 60px">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="searchForm.value"
              clearable
              style="width: 316px"
              :placeholder="$t('dict.searchPlaceHolder')"
              @keyup.enter.native="handleSearch"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search cursor-p"
                @click="handleSearch"
              />
            </el-input>
          </el-form-item>
          <el-form-item
            v-if="visibleResource('create_dict_button')"
            class="float-right"
            style="margin-right: 0"
          >
            <el-button
              icon="el-icon-circle-plus-outline"
              type="primary"
              @click="addDict(true)"
            >
              {{ $t('dict.newDict') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <CustomTable
        ref="customTable"
        :loading="loading"
        :table-data="tableData"
        :pagination="pagination"
        @handleSizeChange="handlePaginationChange"
        @handleCurrentChange="handlePaginationChange"
      >
        <el-table-column
          prop="dictName"
          :label="$t('dict.dictName')"
        />
        <el-table-column
          prop="dictCode"
          :label="$t('dict.dictCode')"
        />
        <el-table-column
          prop="dictPermission"
          :label="$t('dict.dictPermission')"
          :formatter="isSysFormatter"
        ></el-table-column>
        <el-table-column
          prop="dictStatus"
          :label="$t('dict.dictStatus')"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.dictStatus === 'ENABLED' ? 'success' : 'danger'">
              {{ dictStatusTrans(scope.row.dictStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="备注"
        />
        <el-table-column
          prop="updateTime"
          :label="$t('dict.updateTime')"
        />
        <el-table-column
          :label="$t('common.action')"
          width="140"
        >
          <template slot-scope="scope">
            <el-button
              v-if="isSystem ? true : visibleResource('detail_button')"
              type="text"
              class="cursor-p"
              @click="handleView(scope.$index, scope.row)"
            >
              {{ isSystem ? $t('common.view') : getLabel('detail_button') }}
            </el-button>
            <el-button
              v-if="isSystem ? true : (scope.row.dictPermission !== 'SYSTEM' && visibleResource('edit_button'))"
              type="text"
              class="cursor-p"
              @click="handleEdit(scope.row)"
            >
              {{ isSystem ? $t('common.edit') : getLabel('edit_button') }}
            </el-button>
            <el-button
              v-if="isSystem ? true : (scope.row.dictPermission === 'BUSINESS' && visibleResource('delete_button'))"
              type="text"
              class="cursor-p colorRed"
              @click="handleDelete(scope.row)"
            >
              {{ isSystem ? $t('common.delete') : getLabel('delete_button') }}
            </el-button>
          </template>
        </el-table-column>
      </CustomTable>
    </div>
    <add-edit-dialog
      :visible="dialogVisible"
      :oper-type="operType"
      :is-system-admin="isSystemAdmin"
      :dialog-data="dialogData"
      :title="title"
      @success="handleUpdateList"
    ></add-edit-dialog>
    <!-- 查看弹框 -->
    <view-dialog
      :visible="dialogViewVisible"
      :dialog-view-data="dialogViewData"
      @toEdit="toEdit"
    ></view-dialog>
    <delete-dialog
      layout="left"
      :visible.sync="deleteDialogVisible"
      :content="deleteContent"
      :loading.sync="deleteLoading"
      @confirm="handleDeleteConfirm"
    />

    <!-- 导入|导出弹框 -->
    <upload-dialog
      ref="uploadDialog"
      :visible.sync="uploadDialogVisible"
      :error-data="errorData"
      @fileUpload="fileUpload"
      @fileDownload="templeteExcelExport"
      @errorDownLoad="errorDownLoad"
    />
  </div>
</template>

<script>
import ExcelApi from "@/api/excel";
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
import AddEditDialog from "./components/add-edit-dialog.vue";
import ViewDialog from "./components/view-dialog.vue";
import Dict from "@/api/dict/dict";
import UploadDialog from "@/components/common/Dialogs/newUploadDialog";
import { mapGetters } from "vuex";
import { schemaMixins } from "@/mixin/schema";

export default {
  name: "DictList",
  components: {
    AddEditDialog,
    "view-dialog": ViewDialog,
    DeleteDialog,
    UploadDialog
  },
  mixins: [schemaMixins],
  props: {
    isInit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["isSystem", "tenantId", "userId", "isTenant"])
  },
  watch: {
    "searchForm.value"(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleSearch();
      }
    }
  },
  data() {
    return {
      resourceCode: "dict-list",
      // excel start
      errorData: {
        isShow: false,
        ButtonState: false
      },
      errorAttachmentId: "",
      attachName: "",
      uploadDialogVisible: false,
      // excel end
      searchForm: {
        value: ""
      },
      loading: false,
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      tableData: [],
      dicTableData: [{}],
      viewDicTableData: [],
      currentPage: 1,
      dialogViewVisible: false,
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteId: 0,
      dialogVisible: false,
      operType: "add",
      dialogData: {},
      isSystemAdmin: true,
      dialogViewData: {},
      deleteContent: {
        title: this.$t("dict.delete.title"),
        description: this.$t("dict.delete.description")
      },
      isSystemEnum: [
        {
          id: "SYSTEM",
          label: "系统(不可编辑)"
        },
        {
          id: "SYSTEM_BUSINESS",
          label: "系统(可增子项)"
        },
        {
          id: "BUSINESS",
          label: " 业务"
        }
      ],
      dictStatusEnum: [
        {
          id: "ENABLED",
          label: "启用"
        },
        {
          id: "NOT_ENABLED",
          label: "停用"
        }
      ],
      isSystemCaseEnum: [
        {
          id: true,
          label: "是"
        },
        {
          id: false,
          label: "否"
        }
      ],
      title: ""
    };
  },
  created() {
    this.startSearch();
    // 设置是否管理员字段，用于判断是否系统及字典类型
    this.isSystemAdmin = this.isSystem;
  },

  methods: {
    // 根据编码查询模板AttachmentId
    getAttachmentId(templateCode) {
      ExcelApi.getAttachmentId(templateCode).then(res => {
        if (res.success && res.code === 200) {
          this.attachName = res.data.name;
          this.downloadTemplate(res.data.attachmentId);
        }
      });
    },
    // 下载模板
    downloadTemplate(AttachmentId) {
      ExcelApi.downloadAttachment(AttachmentId).then(result => {
        this.streamingFileConversion(result);
      });
    },
    errorDownLoad() {
      // console.log("下载错误日志")
      this.downloadTemplate(this.errorAttachmentId);
    },
    excelImport() {
      this.uploadDialogVisible = true;
    },
    templeteExcelExport() {
      this.getAttachmentId("import_dict");
    },
    // 文件导入
    fileUpload(file) {
      this.errorData.ButtonState = true;
      const data = new FormData();
      data.append("file", file.raw);
      ExcelApi.importExcel(data, "import_dict").then(res => {
        this.errorData.ButtonState = false;
        if (res.success && res.code === 200) {
          this.errorData.attachmentId = res.data.attachmentId;
          this.errorData.isShow = true;
          if (!res.data.success) {
            this.errorData.messageContent = `插入${res.data.successCount}/${
              res.data.totalCount === null ? 0 : res.data.totalCount
            }条数据。${res.data.message}`;
            this.errorData.color = "error";
            this.errorAttachmentId = res.data.attachmentId;
          } else {
            this.errorData.messageContent = `插入${res.data.successCount}/${res.data.totalCount}条数据。`;
            this.errorData.color = "success";
          }
        } else {
          this.$message({
            message: "文件导入失败",
            type: "warning"
          });
        }
      });
    },
    // 文件导出
    exportExcel() {
      const params = {
        search: this.searchForm.value
      };
      ExcelApi.exportExcel(params).then(result => {
        this.streamingFileConversion(result);
      });
    },
    // 流文件的转换
    streamingFileConversion(result) {
      const blob = new Blob([result.data], {
        type: "application/vnd.ms-excel"
      }); // 构造一个blob对象来处理数据
      const fileName = result.filename; // 导出文件名
      /*
       * 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
       * IE10以上支持blob但是依然不支持download
       */
      if ("download" in document.createElement("a")) {
        // 支持a标签download的浏览器
        const link = document.createElement("a"); // 创建a标签
        link.download = fileName; // a标签添加属性
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); // 执行下载
        URL.revokeObjectURL(link.href); // 释放url
        document.body.removeChild(link); // 释放标签
      } else {
        // 其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
    },

    // 获取列表数据
    startSearch() {
      this.loading = true;
      const parmas = {
        "orders[0].asc": "false",
        "orders[0].column": "createTime",
        search: this.searchForm.value,
        size: this.pagination.pageSize,
        page: this.pagination.pageNum
      };
      Dict.getList(parmas)
        .then(res => {
          this.loading = false;
          const { data } = res;
          if (data) {
            const { records = [], total = 0 } = data;
            this.tableData = records;
            this.pagination.total = Number(total);
          }
        })
        .catch(() => {
          this.loading = false;
          // this.$message.warning()
        });
    },

    /*
     * 点击新增按钮弹框 初始化字典页面字典类型为系统(不可编辑)系统(可增子项)
     * 系统管理中的字典类型为业务
     */
    addDict() {
      this.operType = "add";
      if (this.isSystem) {
        this.dialogData = { dictPermission: "SYSTEM", dictStatus: "ENABLED" };
      } else {
        this.dialogData = { dictPermission: "BUSINESS", dictStatus: "ENABLED" };
      }
      this.dialogData.dictItems = [];
      this.dialogVisible = true;
      this.title = this.$t("dictInfo.addDialogTitle");
    },
    // 修改弹框
    handleEdit(row) {
      this.operType = "edit";
      // 获取当前数据
      this.dialogVisible = true;
      Dict.getDictById(row.id)
        .then(res => {
          this.dialogData = { ...row };
          const dictItems = res.data;
          if (dictItems && dictItems.lenght !== 0) {
            this.dialogData.dictItems = JSON.parse(JSON.stringify(dictItems));
          }
          this.title = this.$t("dictInfo.editDialogTitle");
        })
        .catch(() => {
          this.dialogVisible = false;
          // this.$message.warning()
        });
    },
    // 数据删除包含级联子项删除
    handleDelete(row) {
      const { dictStatus } = row;
      if (dictStatus === "ENABLED") {
        this.$message.error("当前字典处于启用状态下，不能被删除，请先停用后再删除！");
        return;
      }
      this.deleteId = row.id;
      this.deleteLoading = false;
      this.deleteDialogVisible = true;
    },

    // 确认删除
    handleDeleteConfirm() {
      this.deleteLoading = true;
      Dict.deleteDictById(this.deleteId).then(res => {
        // 从列表删除数据
        this.deleteDialogVisible = false;
        this.deleteLoading = false;
        this.$message.closeAll();
        this.$message.success(this.$t("dict.deleteSuccess"));
        this.startSearch();
      });
    },
    // 修改前查看
    handleView(index, row) {
      // 获取当前数据
      Dict.getDictById(row.id).then(res => {
        this.viewDictFlag = true;
        this.dialogViewData = { ...row };
        const { data } = res;
        this.dialogViewData.viewDicTableData = data;
        this.dialogViewData.dictPermission = this.isSysTrans(row.dictPermission);
        this.dialogViewData.dictStatus = this.dictStatusTrans(row.dictStatus);
        this.dialogViewVisible = true;
      });
    },

    toEdit() {
      this.handleEdit(this.dialogViewData);
    },
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.tableData = [];
      this.pagination.total = 0;
      this.startSearch();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.startSearch();
    },
    // 页数改变
    handleCurrentChange(val) {
      this.current = val;
      this.startSearch();
    },
    // 是否系统数据转换
    isSysFormatter(row) {
      return this.isSysTrans(row.dictPermission);
    },
    isSysTrans(type) {
      for (let i = 0; i < this.isSystemEnum.length; i++) {
        if (this.isSystemEnum[i].id === type) {
          return this.isSystemEnum[i].label;
        }
      }
    },
    // 字典状态数据转换
    dictStatusFormatter(row) {
      return this.dictStatusTrans(row.dictStatus);
    },
    dictStatusTrans(type) {
      for (let i = 0; i < this.dictStatusEnum.length; i++) {
        if (this.dictStatusEnum[i].id === type) {
          return this.dictStatusEnum[i].label;
        }
      }
    },
    // 级联子表是否系统格式化
    caseCadeIsSystemFormate(row) {
      return this.caseCadeIsSystemTrans(row.systemDefault);
    },
    caseCadeIsSystemTrans(type) {
      for (let i = 0; i < this.isSystemCaseEnum.length; i++) {
        if (this.isSystemCaseEnum[i].id === type) {
          return this.isSystemCaseEnum[i].label;
        }
      }
    },
    viewDialogClosed() {
      this.viewFrom = {};
      this.viewDicTableData = [];
    },
    handleUpdateList() {
      this.startSearch();
    }
  }
};
</script>

<style scoped>
.padding24 {
  padding: 24px;
}

.colorRed {
  color: red;
}

.el-tag {
  height: 23px;
  line-height: 23px;
}
</style>
